import { render, staticRenderFns } from "./Ricerche.vue?vue&type=template&id=49df1395"
import script from "./Ricerche.vue?vue&type=script&lang=js"
export * from "./Ricerche.vue?vue&type=script&lang=js"
import style0 from "./Ricerche.vue?vue&type=style&index=0&id=49df1395&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports